module.exports = __webpack_public_path__ + "media/img/corporate/logos-row-a289b1ea08a4a1dd727be350fc292db8.svg";